<template>
  <v-container fluid>
    <v-row>
      <v-col cols="11" class="mx-auto my-6" align="center">
        <h2>Votre parcours sportif</h2>
        <v-divider></v-divider>
        <UserCalendar :userId="$store.state.user.userId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserCalendar from "@/components/UserCalendar.vue";

export default {
  data() {
    return {
      valid: true,
      personalNote: "",
      personalNoteRules: [
        v =>
          (v && v.length <= 420) ||
          "Vous devez remplir votre note personnelle (440 caractères max)."
      ],
      picker: null,
      pickerRules: [v => !!v || "Veuillez sélectionner une date."]
    };
  },
  components: {
    UserCalendar
  },
  methods: {
    preventWritingOnMaxCharacter(event) {
      const backspace = "Backspace";
      if (this.personalNote.length >= 420 && event.key != backspace) {
        event.preventDefault();
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import "../style/variables";

.calendar {
  height: $calendarHeight;
  margin: 50px 30px;
  width: calc(100% - 60px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: flex-start;
}
</style>